import React from 'react';
import { FiMoreVertical } from 'react-icons/fi';
import styled from 'styled-components';
// import { EyeSvg } from '../../assets/svg-icon-components/EyeSvg';
// import { ShareSvg } from '../../assets/svg-icon-components/ShareSvg';
import { TrashSvg } from '../../assets/svg-icon-components/TrashSvg';
import { RbacPermission } from './rbac/rbac-rules.c';
import { useUserRoles } from '../../util/use-user-role';
import { Can } from './rbac/Can';
import { RhDropdown } from './RhDropdown';
import { Regular } from './Styles';

type Props = {
  userClickedDelete: () => void;
  // userClickedShare?: () => void;
  // userClickedPreview?: () => void;
  isDeleteDisabled?: boolean;
  // isShareDisabled?: boolean;
  // isPreviewDisabled?: boolean;
  deletePermission: RbacPermission;
  // sharePermission?: RbacPermission;
  // previewPermission?: RbacPermission;
};

export const RhMoreDropdown: React.FC<Props> = props => {
  const { roles } = useUserRoles();
  return (
    <RhDropdown trigger={<FiMoreVertical size={18} />}>
      <MoreDiv>
        {/* <MoreItem onClick={props.userClickedShare} disabled={props.isShareDisabled}>
          <ShareSvg style={styles.moreItemIcon} />
          <Regular weight="600" wrap={0}>
            Share Link
          </Regular>
        </MoreItem> */}
        <Can
          role={roles?.[0]}
          perform={props.deletePermission}
          yes={
            <MoreItem onClick={props.userClickedDelete} disabled={props.isDeleteDisabled}>
              <TrashSvg style={styles.moreItemIcon} />
              <Regular weight="600" wrap={0}>
                Delete
              </Regular>
            </MoreItem>
          }
          no={
            <MoreItem disabled>
              <TrashSvg style={styles.moreItemIcon} />
              <Regular weight="600" wrap={0}>
                Delete
              </Regular>
            </MoreItem>
          }
        />
        {/* <MoreItem onClick={props.userClickedPreview} disabled={props.isPreviewDisabled}>
          <EyeSvg style={styles.moreItemIcon} />
          <Regular weight="600" wrap={0}>
            Preview as Studier
          </Regular>
        </MoreItem> */}
      </MoreDiv>
    </RhDropdown>
  );
};

const styles = {
  moreItemIcon: {
    width: 15,
    height: 15,
  },
};

const MoreDiv = styled.div`
  & > :not(:last-child) {
    margin-bottom: 20px;
  }
`;

const MoreItem = styled.button`
  all: unset;
  appearance: none;
  outline: none;
  cursor: pointer;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  & > :not(:last-child) {
    margin-right: 12px;
  }
  &:disabled {
    opacity: 0.5;
    cursor: auto;
  }
`;
